import { COLORS } from "../../utils/js/constants";

export default function ProviderRegisterStyle(theme) {
    return {
      root: {
        flexGrow: 1,
        backgroundColor: COLORS.grey,
        padding: "20px",
      },
      paper: {
        padding: theme.spacing(4),
        textAlign: 'center',
        color: theme.palette.text.secondary,
      },
      title: {
        color: 'white',
        fontWeight: 'bold',
        marginBottom: '25px'
      },
      submitButton: {
        backgroundColor: COLORS.green,
        color: "white",
        fontWeight: "bold",
        marginLeft: 'auto',
        marginTop: '50px',
        display: 'block',
        width: 197
      },
    }
}
